import { call, put, all, spawn, takeLatest } from 'redux-saga/effects';
import { getItemFromLocalStorage } from 'utils/common';
import request, { appendQueryString } from '../../utils/request';

import {
  GET_PAYMENT_METHODS,
  GET_ACTIVE_GATEWAYS,
  GET_UPFRONT_TDR_PER_PAYMENT_METHOD,
  GET_UPFRONT_TDR_PER_PAYMENT_METHOD_URL,
  GET_PAYMENT_METHODS_URL,
  SAVE_UPFRONT_TDR,
  SAVE_UPFRONT_TDR_URL,
  UPDATE_UPFRONT_TDR,
  UPDATE_UPFRONT_TDR_URL,
} from './constants';

import { showToast } from '../Toast/actions';

import { disableLoaderAction as disableLoader } from './actions';
import { GET_ALL_ROUTES_URL } from '../../constants/url';

export function* getActiveGateways({ data: cb }: any) {
  try {
    const { url, method } = GET_ALL_ROUTES_URL;
    const response = yield call(request, url, { method });
    cb(response);
  } catch (e) {
    yield put(disableLoader());
    yield put(showToast(e));
  }
}

export function* getPaymentMethods({
  data: { paymentMode, network, cb },
}: any) {
  try {
    const { url, method } = GET_PAYMENT_METHODS_URL;
    // final url
    let finalURL = url;
    finalURL = url.replace('$paymentMode$', paymentMode);
    finalURL = finalURL.replace(
      '$merchantId$',
      getItemFromLocalStorage('merchantId'),
    );

    let queryString = '';
    if (network && network.length > 0) {
      queryString += `?network=${network.join('&network=')}`;
    }
    finalURL += queryString;
    // IMP: pass data as network=VISA&network=MASTER
    const response = yield call(request, finalURL, { method });
    cb(response);
    // console.log(data);
  } catch (err) {
    // console.log(err);
    yield put(disableLoader());
    yield put(showToast(err));
  }
}

export function* getUpfrontTDRPerPaymentMethods({
  data: { payload, fetchGateways, status, cb }, // eslint-disable-line
}: any) {
  try {
    //  add pagination logic
    const { url, method } = GET_UPFRONT_TDR_PER_PAYMENT_METHOD_URL;
    let finalURL = url.replace(
      '$merchantId$',
      getItemFromLocalStorage('merchantId'),
    );

    // append the queryString
    let queryString = appendQueryString(payload);
    if (status && status.length > 0) {
      queryString += `&status=${status.join('&status=')}`;
    }

    finalURL += queryString;

    // eslint-disable-next-line redux-saga/yield-effects
    const promiseArr = [call(request, finalURL, { method })];

    if (fetchGateways) {
      promiseArr.push(
        // eslint-disable-next-line redux-saga/yield-effects
        call(request, GET_ALL_ROUTES_URL.url, {
          method: GET_ALL_ROUTES_URL.method,
        }),
      );
    }

    const response = yield all(promiseArr);
    cb(response);
  } catch (err) {
    yield put(disableLoader());
    yield put(showToast(err));
  }
}

export function* saveUpfrontTDR({ data: { payload, cb } }: any) {
  try {
    const { url, method } = SAVE_UPFRONT_TDR_URL;
    const finalURL = url.replace(
      '$merchantId$',
      getItemFromLocalStorage('merchantId'),
    );
    const response = yield call(request, finalURL, {
      method,
      body: JSON.stringify(payload),
    });
    cb(response);
    // console.log(data);
  } catch (err) {
    yield put(disableLoader());
    yield put(showToast(err));
  }
}

export function* updateUpfrontTDR({
  data: { payload, modeCode, cb, errorCb },
}: any) {
  try {
    const { url, method } = UPDATE_UPFRONT_TDR_URL;
    let finalURL = url.replace('$modeCode$', modeCode);
    finalURL = finalURL.replace(
      '$merchantId$',
      getItemFromLocalStorage('merchantId'),
    );
    const response = yield call(request, finalURL, {
      method,
      body: JSON.stringify(payload),
    });
    cb(response);
    // console.log(data);
  } catch (err) {
    if (errorCb) errorCb();
    yield put(disableLoader());
    yield put(showToast(err));
  }
}

export function* getPaymentMethodsSaga() {
  yield takeLatest(GET_PAYMENT_METHODS, getPaymentMethods);
}

export function* getActiveGatewaysSaga() {
  yield takeLatest(GET_ACTIVE_GATEWAYS, getActiveGateways);
}

export function* getUpfrontTDRPerPaymentMethodSaga() {
  yield takeLatest(
    GET_UPFRONT_TDR_PER_PAYMENT_METHOD,
    getUpfrontTDRPerPaymentMethods,
  );
}

export function* saveUpfrontTDRSaga() {
  yield takeLatest(SAVE_UPFRONT_TDR, saveUpfrontTDR);
}

export function* updateUpfrontTDRSaga() {
  yield takeLatest(UPDATE_UPFRONT_TDR, updateUpfrontTDR);
}

// Individual exports for testing
export default function* upfrontTdrDetailsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getPaymentMethodsSaga,
    getUpfrontTDRPerPaymentMethodSaga,
    getActiveGatewaysSaga,
    saveUpfrontTDRSaga,
    updateUpfrontTDRSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
